import {
  CoinWithdrawResponse,
  CoinWithdrawConfirmResponse,
} from "../../../models/response/coinWithdraw.response";

export const COIN_WITHDRAW_REDIRECT_URL = "COIN_WITHDRAW_REDIRECT_URL";
export const COIN_WITHDRAW_ACTIVE_TAB = "COIN_WITHDRAW_ACTIVE_TAB";
export const COIN_WITHDRAW_CONFIRM_RESPONSE = "COIN_WITHDRAW_CONFIRM_RESPONSE";
export const COIN_WITHDRAW_REQUEST_RESPONSE = "COIN_WITHDRAW_REQUEST_RESPONSE";
export const COIN_WITHDRAW_PENDING_FOR_CHARGE =
  "COIN_WITHDRAW_PENDING_FOR_CHARGE";

export interface SetRedirectURL {
  type: typeof COIN_WITHDRAW_REDIRECT_URL;
  payload: {
    redirectUrl?: string;
  };
}

export interface SetCoinWithdrawPendingForCharge {
  type: typeof COIN_WITHDRAW_PENDING_FOR_CHARGE;
  payload: {
    pendingForCharge: boolean;
  };
}

export interface SetActiveTab {
  type: typeof COIN_WITHDRAW_ACTIVE_TAB;
  payload: {
    activeTab?: "rightSide" | "leftSide";
  };
}

export interface SetCoinWithdrawConfirmResponse {
  type: typeof COIN_WITHDRAW_CONFIRM_RESPONSE;
  payload: {
    coinWithdrawConfirmResponse?: CoinWithdrawConfirmResponse;
  };
}

export interface SetCoinWithdrawRequestResponse {
  type: typeof COIN_WITHDRAW_REQUEST_RESPONSE;
  payload: {
    coinWithdrawRequestResponse?: CoinWithdrawResponse;
  };
}

export type CoinWithdrawDispatchType =
  | SetRedirectURL
  | SetActiveTab
  | SetCoinWithdrawRequestResponse
  | SetCoinWithdrawConfirmResponse
  | SetCoinWithdrawPendingForCharge;
